import React, { useEffect, useRef, useState } from "react";
import { useNav } from "../../contexts/NavContext";
import { IoHomeOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { firstNavData } from "../../data/firstNav";

export default function Nav1({ scrolled }) {
  // Navigates
  const navigate = useNavigate();

  // Refs
  const firstHeaderRef = useRef(null);

  // States
  const [index, setIndex] = useState(0);

  // Effects
  useEffect(function () {
    const intervalId = setInterval(() => {
      setIndex((i) => (i + 1) % firstNavData.length);
    }, 4000);

    return () => clearInterval(intervalId);
  }, []);

  // Contexts
  const { search } = useNav();

  return (
    <div
      ref={firstHeaderRef}
      className={`${search ? "pointer-events-none" : "pointer-events-auto"} ${scrolled && "hidden"} z-10 flex h-[2.5rem] items-center justify-between bg-black px-4 text-xs font-semibold uppercase text-white transition-all duration-300 lg:h-[2rem] 2xl:px-16`}
    >
      <IoHomeOutline
        className="hidden cursor-pointer text-lg lg:block"
        onClick={() => navigate("/")}
      />

      <div className="absolute left-1/2 flex -translate-x-1/2 items-center gap-2">
        <span>{firstNavData.at(index).logo}</span>
        <p className="text-center">{firstNavData.at(index).text}</p>
      </div>

      <div className="hidden items-center gap-4 lg:flex">
        <span className="cursor-pointer" onClick={() => navigate("/blogs")}>
          Blog
        </span>
      </div>
    </div>
  );
}
